import { catalogActionTypes } from "../../actionTypes/catalog/catalog.actionTypes";

const initialState = {
  loading: false,
  error: null,
  success: false,
};

const catalogReducer = (state = initialState, action) => {
  switch (action.type) {
    case catalogActionTypes.START_EXPORT_CATALOG_BY_ITEMS:
    case catalogActionTypes.START_EXPORT_CATALOG_BY_CATEGORIES:
    case catalogActionTypes.START_EXPORT_CATALOG_BY_ITEM_GROUPS:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case catalogActionTypes.EXPORT_CATALOG_BY_ITEMS_SUCCESS:
    case catalogActionTypes.EXPORT_CATALOG_BY_CATEGORIES_SUCCESS:
    case catalogActionTypes.EXPORT_CATALOG_BY_ITEM_GROUPS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: true,
      };

    case catalogActionTypes.EXPORT_CATALOG_BY_ITEMS_FAILURE:
    case catalogActionTypes.EXPORT_CATALOG_BY_CATEGORIES_FAILURE:
    case catalogActionTypes.EXPORT_CATALOG_BY_ITEM_GROUPS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
        success: false,
      };

    default:
      return state;
  }
};

export default catalogReducer;

